export const serviceData = {
  'Roofing': {
    imageUrl: '/images/services/roofing/roofing1.webp',
    description: 'Professional roofing services including repair, replacement, and maintenance. We work with all major roofing materials and styles.',
    badgeText: 'Professional Roofing',
    features: [
      'Shingle and tile installation',
      'Roof leak detection and repair',
      'Gutter installation and cleaning',
      'Skylight installation',
      'Roof ventilation systems'
    ]
  },
  'Siding': {
    imageUrl: '/images/services/Siding/siding1.webp',
    description: 'Enhance your home\'s curb appeal and protection with our professional siding installation and repair services.',
    badgeText: 'Curb Appeal Enhancement',
    features: [
      'Vinyl, wood, and fiber cement siding',
      'Siding repair and replacement',
      'Trim and molding installation',
      'Insulation and weatherproofing',
      'Color consultation and design'
    ]
  },
  'Gutters': {
    imageUrl: '/images/services/Gutters/gutters1.webp',
    description: 'Complete gutter installation, repair, and maintenance services to protect your home from water damage.',
    badgeText: 'Gutter Protection Systems',
    features: [
      'Gutter installation and replacement',
      'Gutter cleaning and maintenance',
      'Downspout installation',
      'Gutter guard systems',
      'Water damage prevention'
    ]
  },
  'Repairs': {
    imageUrl: '/images/services/Repairs/repair1.webp',
    description: 'Comprehensive repair services for roofing, siding, and gutters. We fix problems quickly and efficiently.',
    badgeText: 'Expert Repair Services',
    features: [
      'Emergency roof repairs',
      'Facia and Soffit',
      'Siding damage repair',
      'Gutter system repairs',
      'Weather damage restoration'
    ]
  },
  'Windows': {
    imageUrl: '/images/services/Windows/window1.webp',
    description: 'Professional window installation, replacement, and repair services. We offer a wide range of energy-efficient window solutions to improve your home\'s comfort and value.',
    badgeText: 'Window Solutions',
    features: [
      'Window installation and replacement',
      'Energy-efficient windows',
      'Window repair and maintenance',
      'Custom window solutions',
      'Professional installation'
    ]
  }
};

// Default data for services not in the main object
export const getServiceData = (serviceName) => {
  return serviceData[serviceName] || {
    imageUrl: '/images/services/roofing/roofing1.webp',
    description: `Professional ${serviceName.toLowerCase()} services. We provide expert workmanship and quality results for all your home improvement needs.`,
    badgeText: `Professional ${serviceName}`,
    features: [
      'Expert consultation and planning',
      'Quality materials and workmanship',
      'Professional installation',
      'Cleanup and project completion',
      'Warranty and follow-up service'
    ]
  };
};
